import { Skeleton } from '@chakra-ui/react';

// Placeholder for a media frame that has nothing to show yet.
const MediaSkeleton = () => (
  <Skeleton width="100%" height="100%" startColor="background.cloudGray" endColor="background.darkGray" />
);

export default MediaSkeleton;
